export default "__VITE_ASSET__Dsy2_g9u__"